import { render, staticRenderFns } from "./zjkfpgl.vue?vue&type=template&id=7815a77c&scoped=true"
import script from "./zjkfpgl.vue?vue&type=script&lang=js"
export * from "./zjkfpgl.vue?vue&type=script&lang=js"
import style0 from "./zjkfpgl.vue?vue&type=style&index=0&id=7815a77c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7815a77c",
  null
  
)

export default component.exports